<template>
  <vs-table multiple v-model="selected" search :data="goalsOptions" class="assign-goals-table">

    <template slot="header">
      <vs-button :disabled="selectedEmpty" icon-pack="feather" icon="icon-corner-left-down" @click="assignGoalsToMonth">Assign goals to {{periodInWords}}
      </vs-button>
    </template>>

    <template slot="thead">
      <vs-th sort-key="title">Goal</vs-th>
      <vs-th sort-key="dreamId">Dream</vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
        <vs-td :data="data[indextr].title">
          {{ data[indextr].title }}
        </vs-td>

        <vs-td :data="data[indextr].dreamTitle">
          {{ data[indextr].dreamTitle }}
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
import _ from 'lodash'
import { monthYearFormat } from '@/helpers/date'

export default {
  props: {
    currentPeriod: {
      type: [Date, String],
      required: true,
    }
  },
  data () {
    return {
      selected: [],
    }
  },
  computed: {
    goalsOptions () {
      return _.chain(this.$store.getters.goalsWithoutPeriod)
        .map((goal) => Object.assign(goal, { dreamTitle: this.dreamTitle(goal) }))
        .reject((x) => !x.dreamTitle)
        .value()
    },
    goals () {
      return this.$store.getters.goalsWithoutPeriod
    },
    periodInWords () {
      return monthYearFormat(this.currentPeriod)
    },
    selectedEmpty () {
      return _.isEmpty(this.selected)
    }
  },
  methods: {
    dreamTitle (goal) {
      const dream = this.$store.getters.dreamsById[goal.dreamId]
      if (dream) {
        return dream.title
      } else {
        return null
      }
    },
    assignGoalsToMonth () {
      _.each(this.selected, async (selectedGoal) => {
        const goal = _.find(this.goals, (g) => g.id === selectedGoal.id)
        goal.period = this.currentPeriod
        await this.$store.dispatch('UPDATE_GOAL', { goal })
      })
      this.selected = []
      this.$emit('close')
    }
  }
}
</script>
<style>
  .assign-goals-table .con-td-check {
    display: none !important;
  }
</style>
